'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNewEvent = createNewEvent;
/**
 * 创建自定义事件
 * @param {*} eventName
 * @returns
 */
function createNewEvent(eventName) {
  var event = void 0;
  if (typeof Event === 'function') {
    event = new Event(eventName);
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }

  return event;
}